module.exports = __webpack_public_path__ + "static/media/aircraft.a3670ff5.png";